<template>
	<div class="view-list-h">
		<div class="gallery">
			<six-side-img center :centerVideoUrl.sync="videoUrl" :imgUrl="gifUrl" />
			<six-side-img v-for="(item, idx) in dataList" :key="idx"
				:indicatorDirection="`${idx < 3 ? 'right' : 'left'}`"
				:indicatorInvert="idx == 2 || idx == 3" 
				:imgUrl="item.coverImgUrl" :indicatorTxt="item.technicalName"
				@mouseover="() => onMouseover(item)" @click="onClickItem(item.id)" />
		</div>
		<!-- <copy-right /> -->
	</div>
</template>

<script>
	import SixSideImg from '@/components/sixSideImg/index';
	import IndexMixin from './mixins/index.js';
	import CopyRight from '@/components/copyRight';
	export default {
		name: 'ListH',
		mixins: [IndexMixin],
		components: {
			SixSideImg,
			CopyRight
		},
		data() {
			return {
				videoUrl: '',//'https://upload.lanjing.baihualin.cloud/upload/202310161515382093.mp4'
				gifUrl: ''
			}
		},
		methods: {
			onMouseover(item) {
				this.videoUrl = item.videoUrl;
				this.gifUrl = item.gifUrl;
			}
		}
	}
</script>

<style scoped lang="less">
	.view-list-h {
		width: 100%;
		padding-left: calc(50px * var(--scale-rate));
		height: calc(850px * var(--scale-rate));

		.gallery {
			/* control the size */
			--s: calc(240px * var(--scale-rate));
			/* control the gap */
			--g: calc(70px * var(--scale-rate));
			
			position: relative;
			width: 100%;
			height: 100%;
		}

		.gallery>.img-container {
			position: absolute;
			left: calc(50% - var(--s) * sqrt(3) / 2 / 2);
			top: calc(50% - var(--s) / 2);
		}

		.gallery>.img-container:nth-child(2) {
			--_x: calc(var(--s) / 2 * sqrt(3) / 2 + var(--g) / 2); 
			--_y: calc(-75% - var(--g) / 2 * sqrt(3));
		}

		
		.gallery>.img-container:nth-child(3) {
			--_x: calc(var(--s) * sqrt(3) / 2 + var(--g)); 
		}
		
		.gallery>.img-container:nth-child(4) {
			--_x: calc(var(--s) / 2 * sqrt(3) / 2 + var(--g) / 2);
			--_y: calc(75% + var(--g) / 2 * sqrt(3));
		}
		.gallery>.img-container:nth-child(5) {
			--_x: calc(-1 * var(--s) / 2 * sqrt(3) / 2 - var(--g) / 2);
			--_y: calc(75% + var(--g) / 2 * sqrt(3));
		}
		
		.gallery>.img-container:nth-child(6) {
			--_x: calc(-1 * var(--s) * sqrt(3) / 2 - var(--g)); 
		}
		
		.gallery>.img-container:nth-child(7) {
			--_x: calc(-1 * var(--s) / 2 * sqrt(3) / 2 - var(--g) / 2);
			--_y: calc(-75% - var(--g) / 2 * sqrt(3));
		}
	}
</style>